import { render, staticRenderFns } from "./TermsPreview.vue?vue&type=template&id=f28d6608&scoped=true"
import script from "./TermsPreview.vue?vue&type=script&lang=js"
export * from "./TermsPreview.vue?vue&type=script&lang=js"
import style0 from "./TermsPreview.vue?vue&type=style&index=0&id=f28d6608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d6608",
  null
  
)

export default component.exports